import { useEffect, useState } from "react";

/** Visible wait state for long multi-recipe named-variant applies. */
export function ManufacturingNamedVariantApplyWorkingBanner({
  recipeCount,
}: {
  recipeCount: number;
}) {
  const [elapsedSec, setElapsedSec] = useState(0);
  useEffect(() => {
    const started = Date.now();
    const id = window.setInterval(() => {
      setElapsedSec(Math.floor((Date.now() - started) / 1000));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  const minutes = Math.floor(elapsedSec / 60);
  const seconds = elapsedSec % 60;
  const clock =
    minutes > 0 ? `${minutes}:${String(seconds).padStart(2, "0")}` : `${seconds}s`;

  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-lg border border-sky-300 bg-sky-50 px-3 py-3 text-sm text-sky-950 dark:border-sky-800 dark:bg-sky-950/40 dark:text-sky-100"
    >
      <div className="flex items-start gap-3">
        <span
          className="mt-0.5 inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-sky-600 border-t-transparent dark:border-sky-300 dark:border-t-transparent"
          aria-hidden
        />
        <div className="min-w-0 space-y-1">
          <p className="font-semibold">
            Still working — applying to {recipeCount} recipe
            {recipeCount === 1 ? "" : "s"} ({clock})
          </p>
          <p className="text-xs leading-relaxed text-sky-900/90 dark:text-sky-100/85">
            AI drafts a materials effect for each recipe. Larger batches often take a minute or two.
            Keep this tab open; the page is not frozen.
          </p>
        </div>
      </div>
    </div>
  );
}
